<template lang="pug">
    div
        div(v-if="!withAvatar")
            Dropdown(@on-click="setGroupName" transfer v-if="$store.getters.hasMultiGroups||$store.getters.isAdmin")
                a(href="javascript:void(0)" style="font-size: 18px; color: #f8f8f9")
                    | {{ $store.state.queryGroupName }}
                    Icon(type="ios-arrow-down" v-if="$store.getters.hasMultiGroups||$store.getters.isAdmin")
                DropdownMenu(slot="list" v-if="$store.getters.hasMultiGroups||$store.getters.isAdmin")
                    DropdownItem(
                        v-for="(groupName, index) in $store.getters.inGroupNames"
                        :key="groupName"
                        :name="groupName"
                        :selected="groupName == $store.state.queryGroupName"
                        :divided="index == 1"
                    ) {{ groupName }}
            Dropdown(trigger="click" @on-click="gotoRoute")
                a(href="javascript:void(0)" style="font-size: 18px; color: #f8f8f9;") {{ $store.state.userData.username }}
                DropdownMenu(slot="list")
                    DropdownItem(name="/account-info")
                        | {{ $t('main.userInfoText') }}
                    DropdownItem(name="/logout" divided)
                        | {{ $t('main.logoutText') }}
            Dropdown(trigger="click" @on-click="setLocale")
                a(href="javascript:void(0)" style="font-size: 18px; color: #f8f8f9;") {{ $t('main.Mobile.userLang') }}
                DropdownMenu(slot="list")
                    DropdownItem(v-for="language in languageItems" :key="language" :name="language") {{ $t(`main.${language}`)}}    
        Dropdown(trigger="click" @on-click="gotoRoute" v-else)
            a(href="javascript:void(0)"
                style="font-size: 18px; color: #f8f8f9;")  {{ $store.state.userData.username }} / {{ $t('main.Mobile.userLang') }}
            DropdownMenu(slot="list")
                DropdownItem(name="/userinfo") {{ $t("main.userInfoText")}}
                Dropdown(placement="right-start" @on-click="setLocale")
                    DropdownItem {{ $t('main.language') }}
                        Icon(type="ios-arrow-forward")
                    DropdownMenu(slot="list")
                        DropdownItem(v-for="language in languageItems" :key="language" :name="language") {{ $t(`main.${language}`)}}
                Dropdown(placement="right-start" @on-click="setGroupName" v-if="$store.getters.hasMultiGroups||$store.getters.isAdmin" transfer)
                    DropdownItem {{ $t('main.group') }}
                        Icon(type="ios-arrow-forward")
                    DropdownMenu(slot="list")
                        DropdownItem(v-for="(groupName,index) in $store.getters.inGroupNames" :key="groupName" :name="groupName" :selected="groupName == $store.state.queryGroupName" :divided="index == 1") {{ groupName }}
                DropdownItem(name="/logout" divided) {{$t("main.logoutText")}}

</template>
<script>
import bus from "@/libs/bus.js";
import { setUserLang } from "@/api/user";

export default {
    name: "MainNavMob",
    components: {},
    data() {
        return {};
    },
    methods: {
        gotoRoute(name) {
            if (name !== "en-US" && name !== "zh-CN" && name !== "zh-TW") {
                this.$router.push(name);
            }
        },
        setLocale(lang) {
            this.$i18n.locale = lang;
            if (lang !== undefined) this.$store.commit("SET_USER_PREF", { lang: lang });
            let i18Title = this.$i18n.t("routesMenu." + this.$router.currentRoute.meta.title);
            document.title = `${i18Title} | ${this.$store.state.platformPrefs.brandTitle}`;
            this.$emit("changeLocale");
            //打後台api
            setUserLang({ userLang: lang })
                .then(response => {
                    console.log(`${response.data.message}`);
                })
                .catch(err => {
                    console.log(`${err.message}`);
                });
        },
        setGroupName(groupName) {
            if (groupName !== undefined) bus.$emit("SET_QUERY_GROUPNAME", groupName);
        }
    },
    mounted() {},
    created() {},
    computed: {
        withAvatar() {
            return this.$store.getters.getUserWithAvatar;
        },
        languageItems() {
            return this.$store.getters.getLanguageItems;
        }
    },
    watch: {},
    sockets: {}
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Main/MainNavMob.vue